/* eslint-disable vue/one-component-per-file */
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import vueI18n from '@/lib/vue-i18n';

const pinia = createPinia();

const mountVueComponent = (el, component, appName = '') => {
  if (!el.offsetParent) {
    return null;
  }

  const app = createApp(
    { ...component, name: appName },
    {
      ...el.dataset,
    },
  );
  app.use(pinia);
  app.use(vueI18n);
  app.mount(el);

  return app;
};

// eslint-disable-next-line import/prefer-default-export
export { mountVueComponent };
